/**
 * Her kiracıda açılan varsayılan gider kategorileri (idempotent; kiracı düzenleyebilir / pasifleştirebilir).
 * Hesap önerileri THP'ye göredir ve "doğrulanmalı" sayılır (docs/domain/regulatory-open-questions.md).
 */
export const DEFAULT_EXPENSE_CATEGORIES = [
    { code: "KIRA", name: "Kira", accountCode: "770.03" },
    { code: "ENERJI", name: "Enerji", accountCode: "770.04" },
    { code: "ELEKTRIK", name: "Elektrik", parentCode: "ENERJI", isUtility: true, accountCode: "770.04" },
    { code: "SU", name: "Su", parentCode: "ENERJI", isUtility: true, accountCode: "770.04" },
    { code: "DOGALGAZ", name: "Doğalgaz", parentCode: "ENERJI", isUtility: true, accountCode: "770.04" },
    { code: "BAKIM_ONARIM", name: "Bakım ve onarım", accountCode: "770.05" },
    { code: "DANISMANLIK", name: "Danışmanlık ve müşavirlik", accountCode: "770.06" },
    { code: "SIGORTA", name: "Sigorta", accountCode: "770.99" },
    { code: "VERGI_RESIM_HARC", name: "Vergi, resim ve harç", accountCode: "770.99" },
    { code: "PAZARLAMA", name: "Pazarlama ve reklam", accountCode: "770.99" },
    { code: "ILETISIM", name: "İletişim", accountCode: "770.99" },
    { code: "TEMIZLIK", name: "Temizlik", accountCode: "770.99" },
    { code: "KIRTASIYE", name: "Kırtasiye", accountCode: "770.99" },
    { code: "ARAC", name: "Araç giderleri", accountCode: "770.99" },
    { code: "NAKLIYE", name: "Nakliye ve kargo", accountCode: "770.99" },
    { code: "DIGER", name: "Diğer genel giderler", accountCode: "770.99" },
];
//# sourceMappingURL=defaults.js.map